import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { bootstrapCatalog, type CatalogData } from "@/services/catalog";

const CATALOG_QUERY_KEY = ["catalog"];

export function useCatalogQuery(): UseQueryResult<CatalogData> {
  return useQuery({
    queryKey: CATALOG_QUERY_KEY,
    queryFn: bootstrapCatalog,
    staleTime: 10 * 60 * 1000,
    retry: 1
  });
}
